import React from 'react';
import classNames from 'classnames';
import {
  Button as ReactButton,
  ButtonProps as ReactButtonProps,
} from 'react-bootstrap';


export interface ButtonProps extends ReactButtonProps {
  children: any
  className?: string
  onClick?: (e: any) => void
  textOnly?: boolean
  iconOnly?: boolean
}

const Button = (
  props: ButtonProps
) => {
  const {
    children,
    className,
    variant,
    textOnly,
    iconOnly,
    ...rest
  } = props;

  return (
    <ReactButton
      {...rest}
      className={classNames(
        className,
        textOnly ? ('btn-text-' + variant) : '',
        iconOnly ? 'btn-icon-only' : '',
      )}
      variant={textOnly ? 'light' : variant} // In order to overwrite the default value
    >
      {children}
    </ReactButton>
  )
}

export default Button;
